import axios from 'src/app-axios';
import Constants from 'src/constants';

export const alert = {
  namespaced: true,
  state: {
    message: '',
    type: '',
  },
  getters: {},
  actions: {
    onAlert (context, alert) {
      context.commit('addAlert', alert);
    },
    async sendAlertResponse ({ dispatch }, payload) {
      const url = `api/devices/alerts/responses/${payload.responseId}`;
      try {
        await axios.post(url, payload.responseGiven);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your response.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
  },
  mutations: {
    addAlert (state, alert) {
      state.message = alert.message;
      state.type = alert.type;
    },
  },
};
